import { BAspect } from './aspect';
import { pluginFactory } from '../../utils/plugins';
var AspectPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BAspect: BAspect
  }
});
export { AspectPlugin, BAspect };


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/bootstrap-vue@2.23.1_jquery@3.7.1_vue@2.6.14/~/bootstrap-vue/esm/components/aspect/index.js
// module id = oPRY
// module chunks = 5